const allHousesChecked = (houses, addressesArray) =>
	houses.every((house) => addressesArray[house.houseId]);

const addHouses = (houses, addressesArray) => {
	const checked = houses.filter((house) => addressesArray[house.houseId]);
	return checked.map((house) => ({
		HouseId: house.houseId,
	}));
};

const addStreets = (streets, addressesArray) => {
	const result = [];
	streets.forEach((street) => {
		const checked = allHousesChecked(street.houses, addressesArray);
		if (checked) {
			result.push({ StreetId: street.streetId });
		} else {
			result.push(...addHouses(street.houses, addressesArray));
		}
	});
	return result;
};

const addRegions = (regions, addressesArray) => {
	const result = [];
	regions.forEach((region) => {
		const allRegionHouses = region.streets.reduce((acc, street) => {
			return [...acc, ...street.houses];
		}, []);
		const checked = allHousesChecked(allRegionHouses, addressesArray);
		if (checked) {
			result.push({ RegionId: region.regionId });
		} else {
			result.push(...addStreets(region.streets, addressesArray));
		}
	});
	return result;
};

export const compressAddressesTree = (addressesArray, companies) => {
	const result = [];
	companies.forEach((company) => {
		const allCompanyHouses = company.regions.reduce((acc, region) => {
			return [
				...acc,
				...region.streets.reduce((acc, street) => {
					return [...acc, ...street.houses];
				}, []),
			];
		}, []);
		const checked = allHousesChecked(allCompanyHouses, addressesArray);
		if (checked) {
			result.push({ ServiceCompanyId: company.companyId });
		} else {
			result.push(
				...addRegions(company.regions, addressesArray).map((item) => ({
					ServiceCompanyId: company.companyId,
					...item,
				}))
			);
		}
	});
	return result;
};
